import styled from 'styled-components'
import { FlexContainer, device } from 'heliocor-ui'

/**
 * This is a FlexContainer for responsive wizard layouts, padding 30px but from midSize 0. 
 */
const AuthenticationLayout = styled(FlexContainer)`
    flex-direction: column;
    padding: 1rem;
    @media ${device.midSize} {
        flex-direction: column;
        padding: 4rem;
    }
`

export {AuthenticationLayout}